<template>
  <div>
    <mdb-card v-if="roundStatus == 'Ready for Timer' && !currentState.iAmInHotSeat">
      <mdb-card-header class="secondary-color text-white"><h4>Ready?</h4></mdb-card-header>
      <mdb-card-body>
        <h3><mdb-icon icon="fire" color="danger"/><b>{{ currentState.hotSeatPlayer }}</b> is in the hot seat!<mdb-icon icon="fire" color="danger"/></h3>

          <p class="text-info">You and other players have to help them guess the
          word or
          phrase without actually using the word(s).</p>
        <div v-if="currentState.iAmModerator">
          <p>Hit <b>Start</b> below when you and the other players are ready to begin the round.</p>
          <mdb-btn icon="clock" @click="$emit('setStatus', 'Timer Running')">Start</mdb-btn>
        </div>
        <div v-if="!game.iAmModerator">
          <span class="spinner-grow text-warning"/>
          <span class="text-warning">Waiting on {{ currentState.moderatorName }} to start the round.</span>
        </div>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="roundStatus == 'Ready for Timer' && currentState.iAmInHotSeat">
      <mdb-card-header class="danger-color text-white">
        <h4><span class="spinner-grow text-white"/>
          <span class="text-white">Waiting on {{ currentState.moderatorName }}...</span></h4>
      </mdb-card-header>
      <mdb-card-body>
        <h3><b><mdb-icon icon="fire" color="danger"/><i>You are in the hot seat!</i><mdb-icon icon="fire" color="danger"/></b></h3>
        <p class="text-info">The other players will soon start giving you clues to unravel the secret word or phrase.</p>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="roundStatus == 'Time Up'">
      <mdb-card-header v-if="timeLeft <= 0" class="secondary-color text-white"><h4>Time's Up!</h4></mdb-card-header>
      <div>
        <span class="spinner-grow text-warning"/>
        <span v-if="!currentState.iAmModerator" class="text-warning"> Waiting on {{ currentState.moderatorName }} to finish the round.</span>
      </div>
    </mdb-card>

    <mdb-card v-if="roundStatus == 'Timer Running'">
      <mdb-card-header v-if="timeLeft > 0" class="primary-color text-white"><h4>Timer Running!</h4>
      </mdb-card-header>

      <mdb-card-body>
        <div v-if="timeLeft > 0 ">
          <mdb-progress :value="progressValue"/>
          <h3>{{ timeLeft }}</h3>
          <div v-if="currentState.iAmInHotSeat">
            <h3>
              <mdb-icon icon="fire" color="danger" class="animated bounce infinite"/>
            Try to guess the word, person or phrase based on the clues you are getting.
              <mdb-icon icon="fire" color="danger" class="animated bounce infinite"/>
            </h3>
          </div>
          <div v-if="!currentState.iAmInHotSeat">
            <mdb-card>
              <mdb-card-header class="secondary-color text-white">
                <h4>The Secret Is....</h4>
              </mdb-card-header>
              <mdb-card-body class="text-center">
                <mdb-row>
                  <mdb-col md="4">&nbsp;</mdb-col>
                  <word-card :card="{class: 'secondary-color-dark text-white', text: currentState.currentCard.front}"/>
                  <mdb-col md="4">&nbsp;</mdb-col>
                </mdb-row>
                <div class="text-info">Give clues to {{ currentState.hotSeatPlayer }} without using the word(s) above.
                </div>
              </mdb-card-body>
            </mdb-card>

          </div>
        </div>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="currentState.iAmModerator && (roundStatus == 'Timer Running' || roundStatus == 'Time Up')"
              class="mt-4">
      <mdb-card-body>
        <h4>Did {{ currentState.hotSeatPlayer }} get it right?</h4>
        <div>
          <mdb-btn color="success" icon="check" @click="$emit('setStatus', 'Hot Seat Yes')">Yes</mdb-btn>
          <mdb-btn v-if="roundStatus=='Time Up'" color="danger" icon="times-circle" @click="$emit('setStatus', 'Hot Seat No')">No
          </mdb-btn>
        </div>
        <mdb-btn color="danger" icon="exclamation" rounded
                 size="sm" @click="showDemeritModal=true">Somebody Used The Word
        </mdb-btn>
        <mdb-btn color="danger" icon="exclamation" rounded
                 size="sm" @click="$emit('setStatus', 'Restart')">There was a problem...Try another word/phrase.
        </mdb-btn>
      </mdb-card-body>
    </mdb-card>

    <scoreboard v-if="currentState.currentStatus == 'Review Scores'"
                :currentState="currentState" :game="game"/>

    <mdb-modal v-if="showDemeritModal" @close="showDemeritModal = false">
      <mdb-modal-header :close="true" class="secondary-color text-white"><h4>Who Messed Up?</h4></mdb-modal-header>
      <mdb-modal-body>
        <div v-for="(player,i) in currentState.players" :key="i" class="mb-2">
          <div v-if="player.playerId != currentState.hotSeatPlayerId">
            <a href="" @click.prevent="giveDemerit(player)">
              <avatar :avatar="player.avatar" :name="player.name"/>
              {{ player.name }}
            </a>
            <div style="clear:both;"></div>
          </div>
        </div>

        <mdb-btn icon="minus-circle" @click="showDemeritModal=false">Never Mind</mdb-btn>

      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="hotSeatModal" centered class="text-center animated rotateIn" elegant
               removeBackdrop size="sm">
      <mdb-modal-header :close="false" center class="primary-color-dark text-white">
        <h3>In the Hot Seat</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <h1>
          <mdb-icon icon="fire" color="danger"/>
          {{ currentState.hotSeatPlayer}}
          <mdb-icon icon="fire" color="danger"/>
        </h1>
        <h3>{{ currentState.moderatorName}} Moderating <mdb-icon icon="user-clock"/></h3>
      </mdb-modal-body>
    </mdb-modal>

  </div>
</template>
<script>
import Avatar from "../common/Avatar";
import {
  mdbBadge,
  mdbBtn,
  mdbBtnFixed,
  mdbBtnFixedItem,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChipInput,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbJumbotron,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbProgress,
  mdbRow,
  mdbSpinner,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import WordCards from "./WordCards";
import WordCard from "./WordCard";
import moment from 'moment'
import Scoreboard from "./Scoreboard";
import api from "../../services/groupsPlaceApi";

export default {
  name: "campfire-timed-q-play",
  components: {

    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbIcon,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalTitle,
    mdbChipInput,
    mdbMask,
    mdbBadge,
    mdbSpinner,
    mdbJumbotron,
    mdbBtnFixed,
    mdbBtnFixedItem,
    mdbProgress,
    mdbRow,
    mdbCol,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    Avatar,
    WordCards,
    WordCard,
    Scoreboard
  },
  watch: {
    roundStatus(n, o) {
      if (n == "Timer Running") this.monitorTime()
    },
    hotSeatPlayer(n,o) {
      if (!n) return
      this.hotSeatModal = true
      setTimeout(() => {
        this.hotSeatModal = false
      }, 1100)
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    currentUser() {
      return this.$store.state.userDetails
    },
    settings() {
      return this.$store.state.settings
    },
    lastError() {
      if (!this.game) return null
      else return this.game.lastError
    },
    roundStatus() {
      return this.currentState.currentStatus
    },
    hotSeatPlayer() {
      return this.currentState.hotSeatPlayerId
    }
  },
  props: {
    currentState: {
      type: Object,
      default: null
    },
    game: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showDemeritModal: false,
      progressValue: 0,
      timeLeft: 10,
      hotSeatModal: false
    }
  },
  mounted() {
    if (this.roundStatus == "Timer Running") this.monitorTime()
  },
  methods: {
    monitorTime() {
      if (this.roundStatus != "Timer Running") return
      this.timeLeft = (moment(this.currentState.timeUp)).diff(moment()) / 1000
      if (this.timeLeft <= 0) this.progressValue = 100
      else {
        this.progressValue = Math.round((this.timeLeft / 15) * 100)
      }
      if (this.timeLeft > 0) {
        setTimeout(() => {
          this.monitorTime()
        }, 500)
      } else (this.currentState.currentStatus = "Time Up")
    },
    giveDemerit(player) {
      console.log("Give demerit to ", player)
      this.showDemeritModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/demerit/" + this.game.sessionId, {playerId: player.playerId, accessToken: this.game.accessToken}).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};
</script>
